import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { DeviceDetailSaveModel } from '../../device-details/models/device-detail-save.model';

export const addDevice = createAction('[Add Device] Add Device');

export const createDevice = createAction('[Create Device] Create Device', props<{ device: DeviceDetailSaveModel }>());

export const createDeviceAndAddAnother = createAction(
   '[Create Device] Create Device and Add Another',
   props<{ device: DeviceDetailSaveModel; accountName: string }>()
);

export const createDeviceSuccess = createAction(
   '[Add Device] Create Device Success',
   props<{ deviceId: number; deviceType: string | null; accountId: number | null }>()
);

export const createDeviceAndAddAnotherSuccess = createAction(
   '[Add Device] Create Device and Add Another Success',
   props<{ deviceId: number; deviceType: string | null; accountId: number; accountName: string }>()
);

export const createDeviceFailure = createAction('[API] Create Device Failure', props<SingleGraphError>());

export const createDeviceAndAddAnotherFailure = createAction(
   '[API] Create Device and Add Another Failure',
   props<SingleGraphError>()
);

export const setDeviceTypeOnForm = createAction(
   '[Add Device] Set Device Type on Form',
   props<{ deviceType: string | null }>()
);
